import { Controller } from "@hotwired/stimulus"

// Search entry points remember where the user came from, and the close
// control returns there wholesale. Deliberately not history.back():
// refinements push history states for browser back/forward (#2447),
// and the close control must not walk through them (#1996).
//
// The origin lives only between the entry click and any departure from
// search: it is consumed on close and cleared by navigation to a
// non-search page, so a later direct or shared-link visit falls back
// instead of jumping to a stale origin.
const ORIGIN_KEY = "search-origin"

export default class extends Controller {
  rememberOrigin() {
    // A refinement from inside search (a pill on a result, #3064) keeps the
    // page the search was entered from; the close control exits wholesale.
    if (window.location.pathname.startsWith("/search")) return

    sessionStorage.setItem(ORIGIN_KEY, window.location.href)
  }

  clearOnExit(event) {
    if (!event.detail.url.includes("/search")) {
      sessionStorage.removeItem(ORIGIN_KEY)
    }
  }

  back() {
    const origin = sessionStorage.getItem(ORIGIN_KEY)
    sessionStorage.removeItem(ORIGIN_KEY)
    if (origin) {
      window.Turbo.visit(origin)
    } else if (window.history.length > 1) {
      window.history.back()
    } else {
      window.Turbo.visit("/")
    }
  }
}
